<template>
  <div class="menu">
    <template v-for="(menu, index) in menus">
      <div @click="changeMenu(index)" :key="index" :class="`item ${activeKey === index ? 'active' : ''} ${bindStatu.statu === 'unbind' && index > 0 ? 'disable' : ''}`">{{menu.name}}</div>
    </template>
    <div @click="changebindStatu" class="item">
      <i :class="`icon-lg ${bindStatu.class}`" :title="bindStatu.text">
        <zx-icon type="icon-wanbiaobangding"></zx-icon>
      </i>
    </div>
    <div @click="changeShownMode" class="item">
      <i :class="`icon-lg ${shownMode.class}`" :title="shownMode.text">
        <zx-icon :type="shownMode.icon"></zx-icon>
      </i>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      bindStatu: {statu: 'all', class: 'icon-online', text: this.$t('home.allPerson')},
      // bindStatus: [
      //   {statu: 'all', class: 'icon-online', text: this.$t('home.allPerson')},
      //   {statu: 'bind', class: 'icon-info', text: this.$t('home.bindWatch')},
      //   {statu: 'unbind', class: 'icon-offline', text: this.$t('home.unbindWatch')}
      // ],
      shownMode: {mode: 'tree', class: 'icon-online', text: this.$t('home.tree'), icon: 'icon-Group'},
      // shownModes: [
      //   {mode: 'tree', class: 'icon-online', text: this.$t('home.tree'), icon: 'icon-Group'},
      //   {mode: 'list', class: 'icon-online', text: this.$t('home.list'), icon: 'icon-liebiao'}
      // ],
      // menus: [
      //   {name: this.$t('home.all'), value: 'all'},
      //   {name: this.$t('home.online'), value: 'online'},
      //   {name: this.$t('home.alarm'), value: 'alarm'},
      //   {name: this.$t('home.offline'), value: 'offline'},
      // ],
      activeKey: 0
    }
  },
  computed: {
    // bindStatu () {
    //   return {statu: 'all', class: 'icon-online', text: this.$t('home.allPerson')}
    // },
    bindStatus () {
      return  [
        {statu: 'all', class: 'icon-online', text: this.$t('home.allPerson')},
        {statu: 'bind', class: 'icon-info', text: this.$t('home.bindWatch')},
        {statu: 'unbind', class: 'icon-offline', text: this.$t('home.unbindWatch')}
      ]
    },
    // shownMode () {
    //   return {mode: 'tree', class: 'icon-online', text: this.$t('home.tree'), icon: 'icon-Group'}
    // },
    shownModes () {
      return [
        {mode: 'tree', class: 'icon-online', text: this.$t('home.tree'), icon: 'icon-Group'},
        {mode: 'list', class: 'icon-online', text: this.$t('home.list'), icon: 'icon-liebiao'}
      ]
    },
    menus () {
      return [
        {name: this.$t('home.all'), value: 'all'},
        {name: this.$t('home.online'), value: 'online'},
        {name: this.$t('home.alarm'), value: 'alarm'},
        {name: this.$t('home.offline'), value: 'offline'},
      ]
    }
  },
  methods: {
    changeShownMode () {
      // 改变为下一个图标状态
      let currentIndex = this.shownModes.findIndex((item) => this.shownMode.mode === item.mode)
      // console.log(currentIndex)
      // 最后一个状态
      if (currentIndex + 1 === this.shownModes.length) {
        this.shownMode = this.shownModes[0]
      } else {
        // this.iconStatu = this.iconStatus[currentIndex + 1]
        this.shownMode = {...this.shownModes[currentIndex + 1]}
      }
      this.$emit('onShownModeChange', {
        shownMode: this.shownMode.mode
      })
    },
    changebindStatu () {
      // 改变为下一个图标状态
      let currentIndex = this.bindStatus.findIndex((item) => this.bindStatu.statu === item.statu)
      // console.log(currentIndex)
      // 最后一个状态
      if (currentIndex + 1 === this.bindStatus.length) {
        this.bindStatu = this.bindStatus[0]
      } else {
        // this.iconStatu = this.iconStatus[currentIndex + 1]
        this.bindStatu = {...this.bindStatus[currentIndex + 1]}
      }
      if (this.bindStatu.statu === 'unbind') {
        this.activeKey = 0
      }
      this.$emit('onShowChange', {
        bindStatu: this.bindStatu.statu,
        customType: this.menus[this.activeKey].value
      })
    },
    changeMenu (index) {
      if (this.bindStatu.statu !== 'unbind') {
        this.activeKey = index
        this.$emit('onShowChange', {
          bindStatu: this.bindStatu.statu,
          customType: this.menus[index].value
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import '../../theme/color.less';
.menu {
  // width: 100%;
  height: 50px;
  line-height: 50px;
  // background: #666;
  padding-bottom: 5px;
  border-bottom: 1px solid rgb(97, 97, 97);
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  box-sizing: border-box;
  align-items: center;
  // grid-template-columns: 1fr 1fr;
  .item {
    text-align: center;
    height: 50px;
    line-height: 50px;
    box-sizing: border-box;
    cursor: pointer;
    // background: #999;
  }
  .disable {
    color: @disabled-color;
    cursor: not-allowed; 
  }
  }
  .active {
    color: @primary-color;
    border-bottom: 3px solid @primary-color;
    
    
}
</style>
